import { PickupAbility, PickupConfig } from "../GameConfig/PickupConfig.js";
import Pickup from "./pickup.js";

export default class Shield extends Pickup {
  constructor() {
    super();

    this.image.src = PickupConfig.Shield.IMG_SRC;
    this.spriteWidth = PickupConfig.Shield.SPRITE_WIDTH;
    this.spriteHeight = PickupConfig.Shield.SPRITE_HEIGHT;

    this.totalTime = PickupConfig.Shield.TOTAL_TIME_MS;

    this.ability = PickupAbility.SHIELD;
  }
  enter(player) {
    player.ability.add(PickupAbility.SHIELD);
  }
}
